import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getAdminPracticeOrganicFertilizerApplications, getPracticeOrganicFertilizerApplications } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_FERTILIZERS_APPLICATIONS } from "consts";

import { PracticeFertilizerApplication, WithInjectedName } from "models";

const env = getEnvironment();

export const useGetPracticeOrganicFertilizerApplications = ({ enabled, isAdmin = env.admin }: { enabled?: boolean; isAdmin?: boolean }) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });

  const queryFn = isAdmin ? getAdminPracticeOrganicFertilizerApplications : getPracticeOrganicFertilizerApplications;

  return useQuery<Array<WithInjectedName<PracticeFertilizerApplication>>>({
    queryKey: [GET_PRACTICES_FERTILIZERS_APPLICATIONS, enabled],
    queryFn: async () => {
      const applications = await queryFn({ enabled });
      return applications.map((a) => ({ ...a, name: t(`fertilizerApplications.${a.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
